// Experiment:
// https://ab.daylight.stitchfix.com/expts/1749
export const twentyVsThirtyExp = {
  expectedValues: ['twenty', 'thirty'],
  fallbackValue: 'twenty',
  name: 'aa_growth.fd_30_vs_20_may2026',
};

// Experiment:
// https://ab.daylight.stitchfix.com/expts/1693
// SUP fix pages only. Uses the same 20/30 contract as front door offer
// while keeping allocation control independent from the default pages
export const supFixTwentyVsThirtyExp = {
  expectedValues: ['twenty', 'thirty'],
  fallbackValue: 'twenty',
  name: 'eng.incentives.sup_fix_30_vs_20_feb2026',
};

// Experiment:
// https://ab.daylight.stitchfix.com/expts/1611
export const variantExp = {
  expectedValues: ['promo-dark', 'grapefruit', 'forest', 'citrus'],
  fallbackValue: 'promo-dark',
  name: 'eng.incentives.holiday_slim_banner_variant_2025',
};
